import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { QuestionnaireService } from "../services/questionnaire.service";

@Component({
  selector: 'app-terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.scss']
})
export class TermsOfUseComponent implements OnInit {
  @Input() submitForm;
  isAdvisor = this.questionnaireService.getIsAdvisor();
  constructor(public activeModal: NgbActiveModal,private questionnaireService: QuestionnaireService) { }

  ngOnInit() {
    if(this.questionnaireService.openTermsOfUse ===true){
      this.activeModal.close();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/terms-of-use/terms-of-use.component.ts